import { TipoDomandaDTO } from '@framework/api-client';
import { InquiryTypeStateTag } from '@framework/common-web';
import { useTranslation } from '@framework/i18n';
import { CountdownHumanized, ISODate } from '@framework/ui';
import { Typography } from 'antd';
import React from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';
import { InquiryCategoryRender } from './InquiryCategoryRender';
import { InquiryItemDivider } from './InquiryItemDivider';
import { InquiryRecipientTypeRender } from './InquiryRecipientTypeRender';

const ListItemButtonRow = styled.div`
  padding-top: 12px;
`;
const ListItemStateRow = styled.div`
  padding-bottom: 12px;
`;

export interface IInquiryItemBaseProps {
  inquiry?: TipoDomandaDTO;
  children?: React.ReactNode;
}

export function InquiryItemBase(props: IInquiryItemBaseProps) {
  const { inquiry, children } = props;

  const isMobile = useBreakpoint(down('sm'));

  const { t } = useTranslation();

  if (!inquiry) return null;

  return (
    <div key={inquiry.id}>
      {isMobile && <InquiryItemDivider />}
      {/* <VerticalSpace /> */}
      <ListItemStateRow>
        <InquiryTypeStateTag inquiry={inquiry} />
      </ListItemStateRow>
      {inquiry.dataFine && (
        <ListItemStateRow>
          {t('domanda.copertina.scadenza', 'Scadenza')}:{' '}
          <ISODate
            date={inquiry.dataFine}
            in24Hours
            format="DD/MM/YYYY kk:mm"
          />
        </ListItemStateRow>
      )}
      <InquiryRecipientTypeRender recipients={inquiry.tipiUtenteCardinalita} />
      {inquiry.flAttivaUtentiAbilitati && (
        <Typography.Text>Istanza ad accesso limitato</Typography.Text>
      )}
      <InquiryCategoryRender categories={inquiry.categorie} />
      {inquiry.flMostraCountdown && (
        <CountdownHumanized expireDate={inquiry.dataFine} />
      )}
      <ListItemButtonRow>{children}</ListItemButtonRow>
    </div>
  );
}
